import React, { useContext, useMemo } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import PasswordChangePanel from '../components/panels/PasswordChangePanel';
import { AuthContext } from '../contexts/authContext';
import { useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierPasswordPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  return (
    <Layout
      carrierLoading={!selectedCarrier && authUser?.role !== UserRole.CARRIER}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {(selectedCarrier || authUser?.role === UserRole.CARRIER) && (
        <>
          <StickyPageHeader
            subtitle={selectedCarrier?.name}
            title="Update Password"
          />
          <PasswordChangePanel
            id="user"
            title={
              authUser?.role === UserRole.CARRIER
                ? 'Change User Password'
                : 'Change Admin Password'
            }
          />
        </>
      )}
    </Layout>
  );
};

export default CarrierPasswordPage;
